import React, { useState, useEffect } from 'react';
import { Modal } from './modal';
import { useMutation } from '@apollo/client';
import sendMhdAndPcaToSunriseEhr from '../SendMhdAndPcaToSunriseEhr/graphql/sendMhdAndPcaToSunriseEhr.graphql';

const SendMhdAndPcaToSunriseEhr = ({ consultationId }) => {
  const [setSendingDataToSunrise, { data, loading, error }] = useMutation(sendMhdAndPcaToSunriseEhr);
  const [showPopup, setShowPopup] = useState(false);
  const [showNotification, setShowNotification] = useState(false);
  const flash = document.getElementById('flash_notice');
  const tenSeconds = 10000;

  useEffect(() => {
    if(showNotification) {
      const timer = setTimeout(() => {
        setShowNotification(false)
      }, tenSeconds);
      return () => clearTimeout(timer);
    }
  }, [showNotification]);


  const onHandleClick = () => {
    setShowPopup(!showPopup);
  };
  
  const onHandleSend = () => {    
    setSendingDataToSunrise({ variables: { consultationId } });
    document.querySelector(`#consult_info_for_${consultationId} > td.actions > div > ul > li > ul`).style = 'display:none';
    setShowPopup(!showPopup);
    setShowNotification(!showNotification);
  }
  
  const toastExist = () => document.getElementById('notification_send_mhd_and_pca');
  
  const updateToast = () => {
    const newDiv = document.getElementById('notification_send_mhd_and_pca');
    
    if (loading) { newDiv.innerText = 'Exporting...' };
    
    if (data && data.sendMhdAndPcaToSunriseEhr.success === true) { newDiv.innerText = 'Health Record has been successfully exported.' };
    
    if (error) { newDiv.innerText = `${error}` };
    
    flash.appendChild(newDiv);
  };
  
  const createToast = () => {
    const newDiv = document.createElement('div');
    
    newDiv.className = 'error';
    newDiv.id = 'notification_send_mhd_and_pca';
    
    if (loading) { newDiv.innerText = 'Exporting...' };
    
    if (data && data.sendMhdAndPcaToSunriseEhr.success === true) { newDiv.innerText = 'Health Record has been successfully exported.' };
    
    if (error) { newDiv.innerText = `${error}` };
    
    flash.appendChild(newDiv);
  };

  const removeToast = () => document.getElementById('notification_send_mhd_and_pca').remove();

  if (showNotification) {
    toastExist() ? updateToast() : createToast();
  } else {
    if (toastExist()) removeToast();
  }

  return (
    <div>
      <a onClick={onHandleClick}>Send MHD&PCA to Sunrise EHR</a>
      <div>
        {showPopup && (
          <Modal title="MHD AND PCA EXPORT" open={showPopup} onExit={() => setShowPopup(false)}>
            <div style={{display: "block"}}>
              <b>Would you like to export this patient's medical history and assessment data to the Sunrise EHR?</b>
              <div className="buttons">
                <div style={{ float: "right" }}>
                  <button
                    className="button secondary"
                    type="button"
                    onClick={onHandleClick}
                  >
                    Cancel
                  </button>

                  <button
                    id="send_mhd_pca_button"
                    className="button"
                    style={{ 'marginLeft': '5px'}}
                    type="submit"
                    onClick={onHandleSend}
                  >
                    Yes
                  </button>
                </div>
              </div>
            </div>
          </Modal>
        )}
      </div>
    </div>
  );
};

export default SendMhdAndPcaToSunriseEhr;
